import { Lock } from 'lucide-react'

interface NotAuthorizedViewProps {
  message?: string
}

export function NotAuthorizedView({ message }: NotAuthorizedViewProps) {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-center">
      <div className="mb-4 rounded-2xl bg-gray-100 p-4 text-gray-400">
        <Lock className="h-8 w-8" />
      </div>
      <h3 className="text-base font-semibold text-gray-800">Not authorized</h3>
      <p className="mt-1 text-sm text-gray-500 max-w-xs">
        {message ?? "You don't have permission to view this page."}
      </p>
    </div>
  )
}

export default NotAuthorizedView
